module.exports = __webpack_public_path__ + "static/media/loader.f27cfa4f.gif";